import axios from "axios";
import { msalInstance } from "../../msalInstance";
import { loginRequest } from "../../msalConfig";

const axiosInstance = axios.create();

export const getToken = async () => {
  try {
    const accounts = msalInstance.getAllAccounts();
    if (!accounts || accounts.length === 0) {
      console.warn("No MSAL accounts found, user may need to log in");
      return null;
    }

    const request = {
      ...loginRequest,
      account: accounts[0],
    };

    const response = await msalInstance.acquireTokenSilent(request);
    return response?.accessToken || null;
  } catch (e) {
    console.error("Unable to acquire token silently, trying interactive:", e);
    try {
      const response = await msalInstance.acquireTokenPopup(loginRequest);
      return response?.accessToken || null;
    } catch (popupError) {
      console.error("Interactive token acquisition failed:", popupError);
      window.location.href = "/home";
      return null;
    }
  }
};

// Request interceptor: get token and attach to each request
axiosInstance.interceptors.request.use(
  async (request) => {
    const token = await getToken();
    if (token) {
      request.headers.Authorization = `Bearer ${token}`;
    }
    return request;
  },
  (err) => Promise.reject(err)
);

// Response interceptor: handle 401 and retry with fresh token
axiosInstance.interceptors.response.use(
  (r) => r,
  async (error) => {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const token = await getToken();
        if (token) {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return axiosInstance(originalRequest);
        }
      } catch (e) {
        console.error("Token refresh failed on 401:", e);
        window.location.href = "/home";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
export const axiosInstanceService = { getToken };